(function () {
  'use strict';

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLocaleLowerCase()
      .trim();
  }

  function initDirectory(directory) {
    if (directory.dataset.brandDirectoryReady === 'true') return;
    directory.dataset.brandDirectoryReady = 'true';

    var input = directory.querySelector('[data-brand-search]');
    var clearButton = directory.querySelector('[data-brand-clear]');
    var resetButton = directory.querySelector('[data-brand-reset]');
    var count = directory.querySelector('[data-brand-count]');
    var empty = directory.querySelector('[data-brand-empty]');
    var list = directory.querySelector('[data-brand-list]');
    var items = Array.prototype.slice.call(directory.querySelectorAll('[data-brand-item]'));
    var groups = Array.prototype.slice.call(directory.querySelectorAll('[data-brand-group]'));
    var letterButtons = Array.prototype.slice.call(directory.querySelectorAll('[data-brand-letter]'));
    var selectedLetter = '';
    var inputTimer;

    if (!input || !list || !items.length) return;

    var letterCounts = items.reduce(function (totals, item) {
      var letter = item.dataset.brandLetter || '#';
      totals[letter] = (totals[letter] || 0) + 1;
      return totals;
    }, {});

    letterButtons.forEach(function (button) {
      var letter = button.dataset.brandLetter;
      if (letter && !letterCounts[letter]) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      }
    });

    function readUrlState() {
      var params = new URLSearchParams(window.location.search);
      var requestedLetter = String(params.get('letter') || '').toLocaleUpperCase();
      input.value = params.get('brand') || '';
      selectedLetter = letterCounts[requestedLetter] ? requestedLetter : '';
    }

    function writeUrlState() {
      if (!window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      var query = input.value.trim();

      if (query) url.searchParams.set('brand', query);
      else url.searchParams.delete('brand');

      if (selectedLetter) url.searchParams.set('letter', selectedLetter);
      else url.searchParams.delete('letter');

      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }

    function applyFilters(updateUrl) {
      var query = normalize(input.value);
      var visibleCount = 0;

      items.forEach(function (item) {
        var matchesSearch = !query || normalize(item.dataset.brandName).indexOf(query) !== -1;
        var matchesLetter = !selectedLetter || item.dataset.brandLetter === selectedLetter;
        var visible = matchesSearch && matchesLetter;
        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      groups.forEach(function (group) {
        group.hidden = !group.querySelector('[data-brand-item]:not([hidden])');
      });

      letterButtons.forEach(function (button) {
        var active = button.dataset.brandLetter === selectedLetter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      var total = items.length;
      count.textContent = visibleCount === total
        ? 'Showing ' + total + (total === 1 ? ' brand' : ' brands')
        : 'Showing ' + visibleCount + ' of ' + total + ' brands';
      list.hidden = visibleCount === 0;
      empty.hidden = visibleCount !== 0;
      clearButton.hidden = input.value.length === 0;

      if (updateUrl) writeUrlState();
    }

    input.addEventListener('input', function () {
      window.clearTimeout(inputTimer);
      inputTimer = window.setTimeout(function () {
        applyFilters(true);
      }, 120);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && input.value) {
        input.value = '';
        applyFilters(true);
      }
    });

    clearButton.addEventListener('click', function () {
      input.value = '';
      applyFilters(true);
      input.focus();
    });

    letterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        selectedLetter = button.dataset.brandLetter || '';
        applyFilters(true);
      });
    });

    if (resetButton) {
      resetButton.addEventListener('click', function () {
        input.value = '';
        selectedLetter = '';
        applyFilters(true);
        input.focus();
      });
    }

    window.addEventListener('popstate', function () {
      readUrlState();
      applyFilters(false);
    });

    readUrlState();
    applyFilters(false);
  }

  function initAllDirectories(root) {
    Array.prototype.forEach.call(
      (root || document).querySelectorAll('[data-brand-directory]'),
      initDirectory
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllDirectories(document);
    });
  } else {
    initAllDirectories(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllDirectories(event.target);
  });
}());
